/*
*   Footer组件
*/

import { Row, Col, Divider,ConfigProvider } from 'antd';
import {
    PhoneOutlined,
    AimOutlined,
    GlobalOutlined,
} from '@ant-design/icons';

import WXH from '../../images/wxh.jpg';
import FTL from '../../images/footer-logo.png';
import CNF from '../../incs/Config';

import BA from '../../images/beian-logo.png';
const Footer = () =>{

    return(
        <div style={{ padding: '15px 0'}}>
            <Row style={{ marginTop: 20 }}>
                <Col offset={4} span={2}>
                    <img height={35} src={FTL} alt='logo' />
                </Col>
                <Col span={3}><p><PhoneOutlined /> 联系方式</p></Col>
                <Col span={3}><p><AimOutlined /> 网站地图</p></Col>
                <Col span={3}><p><GlobalOutlined /> 网站声明</p></Col>
                <Col span={4} style={{ textAlign: 'right' }}>
                    <img width={100} height={100} src={WXH} alt='微信号' />
                    <p>扫描关注微信号</p>
                </Col>
            </Row>
            <Row>
                <Col offset={4} span={16}>
                <ConfigProvider
                    theme={{
                        components: {
                            Divider: {
                                colorSplit: '#40444F',
                            },
                        },
                    }}
                    ><Divider />
                </ConfigProvider>
                </Col>
            </Row>
            <Row>
                {
                    CNF.navItems.map((item) => {
                        if(item.key === 'home'){
                            return <Col key={item.key} offset={4} span={2}><a href={'/' + item.key}><h3>{item.label}</h3></a></Col>
                        }else{
                            return <Col key={item.key} span={2}><a href={'/' + item.key}><h3>{item.label}</h3></a></Col>
                        }
                    })
                }
            </Row>
            <Row style={{ marginTop: 15 }}>
                <Col offset={4} span={2}>友情链接：</Col>
                <Col span={2}><a href='https://ant-design.antgroup.com/index-cn' rel='noreferrer' target='_blank'>ant-design</a></Col>
                <Col span={2}><a href='https://ant-design-charts.antgroup.com/' rel='noreferrer' target='_blank'>AntV</a></Col>
                <Col span={2}><a href='https://react.dev/' rel='noreferrer' target='_blank'>react</a></Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
                <Col offset={4} span={2}>版权所有：</Col>
                <Col span={14}>湖南新致腾信息科技有限公司</Col>
            </Row>
            <Row>
                <Col offset={4} span={16}>
                <ConfigProvider
                    theme={{
                        components: {
                            Divider: {
                                colorSplit: '#40444F',
                            },
                        },
                    }}
                    ><Divider />
                </ConfigProvider>
                </Col>
            </Row>
            <div className='footer-bottom'>
                <Row>
                    <Col offset={4} span={16}>
                        <div>服务：提供7x24小时服务支持</div>
                        <div>电话：18107459923</div>
                        <div>地址：怀化市国际陆港经济开发区文化创意产业园武陵山大学生创客社区4楼</div>
                        <div>邮箱：areawen@aliyun.com</div>
                        <div>网址：<a href='http://www.xinzhiteng.top' rel='noreferrer' target='_blank'>http://www.xinzhiteng.top</a></div>
                        <div>Copyright @ 2023&nbsp;&nbsp;<a href='https://beian.mps.gov.cn/#/query/webSearch?code=43120202000348' rel='noreferrer' target='_blank'><img src={BA} alt='' height={20}/></a>&nbsp;&nbsp;<a href='https://beian.mps.gov.cn/#/query/webSearch?code=43120202000348' rel='noreferrer' target='_blank'>湘公网安备43120202000348号</a>&nbsp;&nbsp;&nbsp;&nbsp;<a href='https://beian.miit.gov.cn/#/Integrated/index' rel='noreferrer' target='_blank'>湘ICP备2023033850号</a></div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Footer;